import React from "react";
import { FacilityTab, useLoanDashboard } from "../../contexts";
import { LoanProductType } from "../../hooks/api/types";

export type FacilityNavTab = {
  id: string;
  label: string;
};

export type FacilityNavBarProps = {
  tabs: FacilityNavTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
};

const FacilityNavBar: React.FC<FacilityNavBarProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  const {
    state: { currentLoanApplication },
  } = useLoanDashboard();
  return (
    <div className="cx-max-w-[960px] cx-h-[48px] cx-mx-auto cx-px-4 sm:cx-px-6">
      <div className="cx-flex cx-items-end cx-pt-4 cx-border-b cx-border-neutral-light">
        <div className="cx-flex cx-gap-[12px]">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`cx-relative cx-pb-3 cx-px-3 cx-text-sm cx-font-medium cx-transition-colors -cx-mb-[1px] ${
                activeTab === tab.id
                  ? "cx-text-brand-primary-regular"
                  : "cx-text-text-tertiary hover:cx-text-text-primary"
              }`}
            >
              {" "}
              {tab.id === FacilityTab.VENDORS
                ? currentLoanApplication?.loanType ===
                  LoanProductType.LOC_PAYABLE_FINANCING
                  ? "Suppliers"
                  : "Buyers"
                : tab.label}
              {activeTab === tab.id && (
                <span className="cx-absolute cx-bottom-0 cx-left-0 -cx-right-2 cx-h-[2px] cx-bg-brand-primary-regular" />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FacilityNavBar;
